import { render, staticRenderFns } from "./Acttag.vue?vue&type=template&id=090ae892&scoped=true"
import script from "./Acttag.vue?vue&type=script&lang=js"
export * from "./Acttag.vue?vue&type=script&lang=js"
import style0 from "./Acttag.vue?vue&type=style&index=0&id=090ae892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ae892",
  null
  
)

export default component.exports